import React from "react";
import CaseCardOutline from "./CaseCardOutline";
import Header from "./Header";
import Footer from "./Footer";
import PlotViewLoadingComponent from "../loading/PlotViewLoadingComponent.jsx";


const ElemPlay = React.forwardRef(({Dyn, dynElemPlayContainer, onSwitchToPlotView, reduceCaseCardWidth}, ref) => {
    return (
        <div className={"tde-elem-play-wrapper" + (reduceCaseCardWidth? ' tde-with-reduced-card': '')}>
            <div className="tde-fill">
            <CaseCardOutline />
            <Header
                Dyn={Dyn}
                dynElemPlayContainer={dynElemPlayContainer}
                onFlip={onSwitchToPlotView}
                onReset={() => dynElemPlayContainer.resetPlay()}
                onStackClick={() =>
                    dynElemPlayContainer.onStackClick()
                }
                onIconsClick={() => dynElemPlayContainer.onIconsClick()}
                onCountClick={() => dynElemPlayContainer.onCountClick()}
            />
            <div
                className="tde-plotview-wrapper tde-fill"
                ref={ref}
                tabIndex="0"
                role="region"
                aria-label="Plot Area"
            >
                <PlotViewLoadingComponent Dyn={Dyn} />
            </div>
            {dynElemPlayContainer?.canShowPlotControls && (
                <Footer
                    Dyn={Dyn}
                    type={dynElemPlayContainer?.state.plot}
                    attr={dynElemPlayContainer?.state.attribute}
                    onGroupBy={(attr) =>
                        dynElemPlayContainer.groupBy(attr)
                    }
                    onOrderBy={(attr) =>
                        dynElemPlayContainer.orderBy(attr)
                    }
                />
            )}
            </div>
        </div>
    );
});

export default ElemPlay;
